var $ = require('jQuery');
var Uploader = require('uploader');

module.exports = function() {

    // Setup the Uploader, if included on the page.
    if ($("#uploader").length > 0) {
        var options = uploaderOptions.clarify();
        new Uploader(options);
    }

    // Bind Multi Upload 'Delete' button action.
    $('.images').on('click', '.upload-multi .upload-actions .delete', function () {

        var container = $(this).closest('.upload-multi');
        var fileId = container.find('input.upload-id').val();
        var deletedOrder = container.find('.sort-order').text();

        container.remove();

        $('.images .upload-multi').each(function() {
            var order = $(this).find('.sort-order').text();
            var newOrder = order - 1;
            if (order > deletedOrder) {
                $(this).find('.sort-order').text(newOrder);
            }
        });

        $.ajax({
            'type': 'DELETE',
            'url':  imageDeleteUrl.replace(0, fileId)
        });
    });

};